import { Component } from '@angular/core';


export class SkyEmailValidationDemoComponent {
  public emailValidator: string;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-email-validation-demo',
  template: `<div style="max-width: 50%">
  <input
    [(ngModel)]="emailValidator"
    class="sky-form-control"
    skyEmailValidation
    #email="ngModel">
  <div
    class="sky-error-label"
    *ngIf="email.errors && email.errors.skyEmail && (email.dirty && email.touched)">
    <span [hidden]="!email.errors.skyEmail.invalid">
      Please enter valid email with format joe@abc.com
    </span>
  </div>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
